import { getYaNative } from '@yanolja-org/ya-native';
import axios from 'axios';
import moment from 'moment';
import URI from 'urijs';

import { EN_APP_DEVICE } from '../functions/device/EN_APP_DEVICE';
import { hasNoItems } from '../functions/hasNoItems';

export enum EN_SAUCEFLEX_COLLECT_MESSAGE {
  ENTER = 'flexCollectEnter',
  BROADCAST = 'flexCollectMoveBroadcast',
  PRODUCT = 'flexCollectMoveProduct',
  HEIGHT = 'flexCollectionHeight',
  TOPBANNER = 'flexCollectMoveTopBanner',
}

export enum EN_SAUCEFLEX_PLAYER_MESSAGE {
  ENTER = 'sauceflexEnter',
  EXIT = 'sauceflexMoveExit',
  LOGIN = 'sauceflexMoveLogin',
  PRODUCT = 'sauceflexMoveProduct',
  SHARE = 'sauceflexOnShare',
  PIP = 'sauceflexPictureInPicture',
  BANNER = 'sauceflexMoveBanner',
  INPUTBLUR = 'sauceflexInputBlur',
  COUPON = 'sauceflexMoveCoupon',
  COUPON_ANDROID = 'sauceflexCouponAndroidScheme',
  COUPON_IOS = 'sauceflexCouponIosScheme',
  BANNER_ANDROID = 'sauceflexBannerAndroidScheme',
  BANNER_IOS = 'sauceflexBannerIosScheme',
  PRODUCT_ANDROID = 'sauceflexProductAndroidScheme',
  PRODUCT_IOS = 'sauceflexProductIosScheme',
}

interface ILink {
  weblink: string;
  deeplink: string;
}

export interface IBroadcastInfo {
  broadcastStateCode?: string;
  broadcastName?: string;
  thumbnailUrl?: string;
  programmingStartDt?: string;
}

/**
 * 소스플렉스 어드민에서 http(s) 입력만 가능해서 딥링크를 hash 로 받는다.
 *
 * @param urlStr 어드민에서 등록한 url. {웹링크}#{딥링크} 형태.
 */
export const getLinkFrom = (urlStr: string): ILink => {
  const parsedUrl = URI(urlStr);
  const [weblink, deeplink] = parsedUrl.href().split('#');
  return { weblink, deeplink };
};

/**
 * 각 플랫폼에 맞게 weblink, deeplink 로 이동한다.
 * App 인 경우 PIP 모드를 활성화한다.
 *
 * @param link weblink, deeplink
 */
export const goTo = (link: ILink, appDevice: EN_APP_DEVICE | null, _isPreview?: boolean): void => {
  const yaNative = getYaNative();

  if (yaNative.isEnabled) {
    appDevice === EN_APP_DEVICE.IOS && yaNative.requestPipMode();
    location.href = link.deeplink;
  } else {
    location.href = link.weblink;
  }
};

export const getBroadcastInfo = async (sauceFlexUrl: string, broadcastId: string): Promise<IBroadcastInfo> => {
  const reqStartDate = new Date();
  const sendLog = (message: string): void => {
    console.log(
      JSON.stringify({
        log_id: 'api:getBroadcastInfo',
        duration: new Date().getTime() - reqStartDate.getTime(),
        message,
      }),
    );
  };
  const result = await axios
    .get(`${sauceFlexUrl}/V1/front/broadcast/yanolja/${broadcastId}`)
    .then((res) => {
      if (hasNoItems(res.data.response.items)) {
        sendLog(`Error: ${res.status} : 데이터 없음`);
      }
      const { broadcastStateCode, broadcastName, thumbnailList, programmingStartDt } = res.data.response.items[0];
      const { thumbnailUrl } = thumbnailList[0] || {};
      sendLog(`broadcastStateCode : ${broadcastStateCode}`);

      return {
        broadcastStateCode,
        broadcastName,
        thumbnailUrl,
        programmingStartDt: programmingStartDt ? moment(programmingStartDt).format('M월 D일 a h시') : '',
      };
    })
    .catch((error) => {
      if (error.response) {
        sendLog(`Error : ${error.response.status}`);
      } else if (error.request) {
        sendLog(`Error : ${error.request}`);
      } else {
        sendLog(`Error : ${error.message}`);
      }

      return {};
    });

  return result;
};
